export const zipCodeValidatorRegExp = /^[a-zA-Z\d\s-]+$/;

const validateZIPCode = (string: string): boolean => zipCodeValidatorRegExp.test(string);

export default validateZIPCode;
